import React, { useState, useEffect } from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import { validateField } from '../../utils/validation/validation';
import InputField from '../../utils/InputField';
import TextAreaField from '../../utils/TextAreaField';
import GoogleMapsWrapper from '../../utils/GoogleMapsWrapper';
import PlaceComponent from '../Address/AddressAutoPop';
import { formatPhoneNumber } from '../../utils/phoneFormatter';
import { fetchPublicCommunities } from '../../services/api';

function ApplicantForm({ data, onChange, onValidate, errors, isFrom = 'page' }) {
    const [communities, setCommunities] = useState([]);

    useEffect(() => {
        const loadCommunities = async () => {
            try {
                const res = await fetchPublicCommunities(1, 1000);
                setCommunities(res?.data || []);
            } catch (error) {
                console.error("Failed to load communities", error);
            }
        };
        loadCommunities();
    }, []);

    const handleChange = (field, value) => {
        let processedValue = value;
        
        // Format phone number
        if (field === 'phoneNumber') {
            processedValue = formatPhoneNumber(value);
        }
        
        onChange(field, processedValue);
        const error = validateField(field, processedValue);  // Validate on field change
        onValidate(field, error);
    };

    return (
            <Container className="px-0" fluid>
                <Row className="no-gutters">
                    <Col sm={isFrom === 'page' ? 8 : 12 }>
                        <div className={isFrom === 'page' ? 'form-wrapper rounded' : 'form-wrapper' }>
                            <div className="form-heading mb-4 text-uppercase fw-bold">Permit Applicant Information</div>
                            <Row className="mb-3">
                                <InputField
                                    field="firstName"
                                    label="First Name"
                                    value={data.firstName}
                                    onChange={handleChange}
                                    error={errors.name}
                                    as={Col}
                                />
                                <InputField
                                    field="lastName"
                                    label="Last Name"
                                    value={data.lastName}
                                    onChange={handleChange}
                                    error={errors.name}
                                    as={Col}
                                />
                            </Row>
                            <Row className="mb-3">
                            <GoogleMapsWrapper>
                                <PlaceComponent
                                    field="address"
                                    label="Applicant Address"
                                    className="mb-3"
                                    value={data.address}
                                    onChange={handleChange}
                                    type="text"
                                    error={errors.address}
                                />
                             </GoogleMapsWrapper>    
                           </Row>
                           <Row className="mb-3">
                                <InputField
                                    field="email"
                                    label="Applicant Email"
                                    value={data.email}
                                    onChange={handleChange}
                                    error={errors.email}
                                    type="email"
                                    className="mb-3"
                                    as={Col}
                                />
                           </Row>
                           <Row className="mb-3">
                                <InputField
                                    field="phoneNumber"
                                    label="Applicant Phone Number"
                                    className="mb-3"
                                    value={data.phoneNumber}
                                    onChange={handleChange}
                                    pattern="^[-0-9]*$"
                                    error={errors.phoneNumber}
                                    type="text"
                                    as={Col}
                                /> 
                           </Row>
                           <Row className="mb-3">
                                {/* <InputField
                                    field="communityEmail"
                                    label="Community Email Address"
                                    value={data.communityEmail}
                                    onChange={handleChange}
                                    error={errors.communityEmail}
                                    type="select"
                                    options={communities.map(c => c.communityEmail)}
                                    className="mb-3"
                                    as={Col}
                                /> */}
                                <InputField
                                    field="communityEmail"
                                    label="Community Email Address"
                                    value={data.communityEmail}
                                    onChange={handleChange}
                                    error={errors.communityEmail}
                                    type="email"
                                    className="mb-3"
                                    as={Col}
                                />
                           </Row>
                        </div>
                    </Col>
                    <Col sm={isFrom === 'page' ? 4 : 12 }>
                        <div className="{isFrom === 'page' ? 'form-wrapper rounded' : 'form-wrapper' }">
                            <TextAreaField
                                field="notes"
                                label="Comment Area"
                                value={data.notes}
                                onChange={handleChange}
                                error={errors.notes}
                                placeholder=""
                                as={Col}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
    );
}

export default ApplicantForm;